export const toUpperCase = (list) => list.map((value) => value.toUpperCase());
